<cva-common-dialog [title]="'Patient Search'" [id]="'patientSearch'" [refreshIcon]="false" class="patient-search">
  <div class="position-relative searchContainer">
    <div class="mb-2 position-relative d-flex flex-row align-items-baseline" id="patientId">
      <label class="form-label" for="patientId">
        Patient Id *
      </label>
      <div class="w-100" [ngClass]="{'mt-3':errorMsg}">
        <div class="position-relative">
          <input type="text" class="form-control" #patientId>
          <button type="button" class="search-icon btn-invisible" (click)="searchPatientById(patientId)">
            <i class="bi bi-search"></i>
          </button>
        </div>
        <mat-error *ngIf="errorMsg">No patient found with this id.</mat-error>
      </div>

    </div>
    <div>
      @if (patientDemography.name){
      <button type="button" class="btn generate-element btn-dark ms-3 start-consult-btn" (click)="getAppointments()">
        Start Consultation
      </button>
      }
    </div>
    <div>
      @if (patientDemography.name){
      <button type="button" class="btn generate-element btn-dark ms-3 start-consult-btn" (click)="getclinicalRecord()">
        Get Clinical Records
      </button>
      }
    </div>
  </div>
  @if (patientDemography.name){

  <div class="row">
    <!-- Name -->
    <div class="col-12 col-md-6 col-lg-3">
      <div class="info-container d-flex">
        <span class="info-label">Name:</span>
        <span class="info-value patient-name">
          {{ patientDemography.name }}
        </span>
      </div>
    </div>

    <!-- Gender -->
    <div class="col-12 col-md-6 col-lg-3 mt-3 mt-md-0">
      <div class="info-container d-flex">
        <span class="info-label">Gender:</span>
        <span class="info-value">{{ patientDemography.gender }}</span>
      </div>
    </div>

    <!-- Age -->
    <div class="col-12 col-md-6 col-lg-3 mt-3 mt-md-0">
      <div class="info-container d-flex">
        <span class="info-label">Age:</span>
        <span class="info-value patient-age">{{ patientDemography.dateOfBirth | age }}</span>
      </div>
    </div>

    <!-- Empty space for future use -->
    <div class="col-12 col-md-6 col-lg-3 mt-3 mt-md-0">
      <div></div>
    </div>
  </div>
  @if (showClinicalData){
  <mat-tab-group animationDuration="0ms" class="tab-view" mat-stretch-tabs="false" mat-align-tabs="start" #tabGroup
    (selectedTabChange)="onTabChanged($event)">
    <mat-tab label="Consultations">
      @if(consultationHistoryCurPage.length){
      <div class="consultation-history-container">
        @for (history of consultationHistoryCurPage; track history) {
        <mat-accordion>
          <mat-expansion-panel class="mb-10">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{history.soapNoteDate | date : 'd MMM, y'}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              @if (history.subjective){
              <div [innerHTML]="history.subjective"></div>
              }
              @if (history.objective){
              <div [innerHTML]="history.objective"></div>
              }
              @if(history.assessment) {
              <div [innerHTML]="history.assessment"></div>
              }
              @if(history.plan) {
              <div [innerHTML]="history.plan"></div>
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        }
      </div>
      <div class="d-flex align-items-end justify-content-end flex-column">
      <mat-paginator #paginator class="demo-paginator" (page)="handleConsultationHistoryPageEvent($event)"
        [length]="consultationHistory.length" [pageSize]="consultationHistoryPageSize"
        [pageIndex]="consultationHistoryPageIndex" [showFirstLastButtons]="true"
        [hidePageSize]="consultationHistoryCurPage.length">
      </mat-paginator>
        <button
        *ngIf="shouldShowViewMore(ClinicalRecordTab.ConsultationSummary)"        
        (click)="getMedicalSummaryData()"
        class="btn btn-dark btn-sm "
        >
        View More
      </button>
      </div>
      }@else {
      <div class="no-records-found text-center mt-2 norecord">
        No Record Found.
      </div>
      }
    </mat-tab>
    <mat-tab label="Observations">
      @if (vitalsColumns.length === 1) {
      <div class="no-records-found text-center mt-2 norecord">
        No Record Found.
      </div>
      }@else {
      <cva-data-table [displayedColumns]="vitalsColumns" [tableData]="vitalData" tableClass="mat-elevation-z1"
        [stickyColumnIndex]="stickyColumnPosition" [showPagination]="false" [hidePageSize]="true"></cva-data-table>
        <div class="d-flex align-items-end justify-content-end flex-column mt-2"          *ngIf="shouldShowViewMore(ClinicalRecordTab.Observations)"   >
          <button  
          (click)="getVitalSignsData()"
          class="btn btn-dark btn-sm "
          >
          View More
        </button>
      </div>
      }
    </mat-tab>
    <mat-tab label="Allergies">
      @if(allergiesData.length){
      <cva-data-table [displayedColumns]="allergiesColumns" [tableData]="allergiesData" tableClass="mat-elevation-z1"
        [stickyColumnIndex]="stickyColumnPosition" [showPagination]="allergiesData.length > 0" [hidePageSize]="true"
        [pageSize]="pageSize"></cva-data-table>
      }@else {
      <div class="no-records-found text-center mt-2 norecord">
        No Record Found.
      </div>
      }
    </mat-tab>
    <mat-tab label="Lab Results">
      @if (labResultsPage.length) {
      <mat-accordion multi>
        <ng-container *ngFor="let item of labResultsPage; let idx = index">
          <mat-expansion-panel class="mb-10">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ item.date }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container *ngFor="let val of item.entries; let j = index">
              <mat-expansion-panel class="mb-10">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ val.displayName }}
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div *ngFor="let html of val.resultData" [innerHTML]="getSafeHTML(html)"></div>
              </mat-expansion-panel>
            </ng-container>
          </mat-expansion-panel>
        </ng-container>
      </mat-accordion>

      <mat-paginator #paginator class="demo-paginator" (page)="handleLabResultsPageEvent($event)"
        [length]="labDataArray?.length" [pageSize]="labResultsPageSize" [pageIndex]="labResultsPageIndex"
        [showFirstLastButtons]="true" [hidePageSize]="labResultsPage.length">
      </mat-paginator>
      }@else {
      <div class="no-records-found text-center mt-2 norecord">
        No Record Found.
      </div>
      }
    </mat-tab>
    <mat-tab label="Medication">
      @if (medicalRequestCurPage.length) {
      <div>
        <mat-accordion multi>
          <ng-container *ngFor="let item of medicalRequestCurPage; let idx = index">
            <mat-expansion-panel class="mb-10">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ item.date | date }}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="medical-request">
                <cva-data-table [displayedColumns]="columns" [tableData]="item.table" tableClass="mat-elevation-z1"
                  [stickyColumnIndex]="stickyColumnPosition" [showPagination]="false" [hidePageSize]="true">
                </cva-data-table>
              </div>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
      </div>
      <div class="d-flex align-items-end justify-content-end flex-column">
      <mat-paginator #paginator class="demo-paginator" (page)="handleMedicationRequestPageEvent($event)"
        [length]="medicalRequestData.length" [pageSize]="medicationRequestPageSize"
        [pageIndex]="medicationRequestPageIndex" [showFirstLastButtons]="true"
        [hidePageSize]="medicalRequestData.length">
      </mat-paginator>
       <button
        *ngIf="shouldShowViewMore(ClinicalRecordTab.MedicationRequest)"          
        (click)="getMedicationRequestData()"
        class="btn btn-dark btn-sm "
        >
        View More
      </button>
      </div>
      }@else {
      <div class="no-records-found text-center mt-2 norecord">
        No Record Found.
      </div>
      }
    </mat-tab>
    <mat-tab label="Immunization">
      @if(immunizationsData.length){
      <cva-data-table [displayedColumns]="immunizationColumns" [tableData]="immunizationsData"
        tableClass="mat-elevation-z1" [stickyColumnIndex]="stickyColumnPosition"
        [showPagination]="immunizationsData.length > 0" [hidePageSize]="true" [pageSize]="pageSize"></cva-data-table>
      }@else {
      <div class="no-records-found text-center mt-2 norecord">
        No Record Found.
      </div>
      }
    </mat-tab>
  </mat-tab-group>
  }
  @if(showAppointmentData){
  <div class="pt-4 info-value patient-name">Existing Appointments</div>
  <!-- Mobile screen -->
  <div class="d-block d-sm-none px-3 ">
    <ng-container *ngIf="appointments && appointments.length > 0;else noRecordFound">
      <div class="my-2" *ngFor="let appointment of appointments" aria-hidden="true">
        <cva-appointment-card [appointment]="appointment" (actionClick)="onActionClick($event)"
          (rowClick)="openExistingConsultation($event)" cvaAuthPermCheck [moduleName]='CVA_AUTH_MODULES.CVA_SOAP_NOTES'
          [permissionType]='CVA_CONSTANTS.PERMISSION.WRITE' [actionType]='"disable"'></cva-appointment-card>
      </div>
    </ng-container>

    <ng-template #noRecordFound>
      <div class="row apt-container justify-content-center mb-4 p-4 text-grey">
        <mat-card>
          <mat-card-content class="text-center">
            <strong>No Record Found.</strong>
          </mat-card-content>
        </mat-card>
      </div>
    </ng-template>
  </div>
  <!-- Desktop Screen -->
  <div class="d-none d-sm-block px-3 ">
    <div class="table-container">
      <div class="table-container text-capitalize">
        <cva-data-table [displayedColumns]="displayedColumns" [tableData]="appointments" [pageSize]="3"
          [pageSizeOptions]="[5,10,15,20,25,30]" [tableClass]="'appointments-table'" [isEditable]="false"
          [isDeletable]="false" [isRowClickable]="true" [skipConfirmationPopup]="true"
          (rowClick)="openExistingConsultation($event)" (actionClick)="onActionClick($event)"></cva-data-table>
      </div>
    </div>
  </div>
  <div class="pt-2">
    <div class="info-value text-center">
      <span>Start new Consultation? </span>
      <button type="button" class="no-button blink" (click)="startNewConsultation()"><span class="text-primary">Yes
        </span></button>
      <button type="button" class="no-button blink" (click)="closePopUp()"> <span
          class="text-primary">No</span></button>
    </div>
  </div>
  }
  }

</cva-common-dialog>